import { BankAccountGrid } from "interfaces";
import { makeAutoObservable, runInAction } from "mobx";
import { fetchGetBankAccounts, NormalizedError } from "services";
import { statusFetching } from "services/authClient/constants/types";

export class BankAccountsStore {
  bankAccounts: BankAccountGrid[] = [];
  selectedAccountId: string | undefined;
  loading = false;
  error: string | null = null;

  public fetchStatus: statusFetching = "init";
  public fetchError?: NormalizedError;

  constructor() {
    makeAutoObservable(this);
  }

  get isPending() {
    return this.fetchStatus === "fetching";
  }

  get defaultAccountId() {
    return this.bankAccounts.find((i) => i.isDefault);
  }

  async fetchBankAccounts(companyId: string) {
    runInAction(() => {
      this.fetchStatus = "fetching";
      this.fetchError = undefined;
    });

    try {
      const response = await fetchGetBankAccounts({ id: companyId });
      runInAction(() => {
        this.bankAccounts = response;
        this.fetchStatus = "success";
      });
      return response;
    } catch (error: any) {
      runInAction(() => {
        this.fetchStatus = "error";
        this.fetchError = error;
      });
    }
  }

  setSelectedAccountId(id: string) {
    this.selectedAccountId = id;
  }

  clearError() {
    runInAction(() => {
      this.error = null;
    });
  }
}
